module.exports = __webpack_public_path__ + "img/2_223.952fd9c4.png";